<template>
  <div class="wrapper">
    <div class="main">
      <div class="list">
        <div class="item" v-for="(item,index) in list" :key="index">
          <div class="img-wrap">
            <img v-lazy="item.club.cover" :alt="item.club.title" v-if="item.club">
          </div>
          <div class="title">{{item.club.title}}</div>
          <!-- <div class="price">{{item.goods.price}}元</div> -->
          <div class="actions">
            <a href="javascript:;" class="del" @click="delCollete(item.club ,index)">{{$t('del')}}</a>
            <a href="javascript:;" class="detail" @click="lookDetail(item.club.id)">{{$t('detail')}}</a>
          </div>
        </div>
      </div>
      <template v-if="list.length>0">
        <Pagination :totalPage="totalPage" :limit="limit" @changePage="handOrderMore"></Pagination>
      </template>
      <template v-else>{{$t('noCollectionArrow')}}</template>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/common/Pagination.vue";
export default {
  name: "Favourite",
  components: { Pagination },
  props: {},
  data() {
    return {
      list: [],
      totalPage: 0,
      page: 1,
      limit: 10
    };
  },
  methods: {
    getFavList() {
      let data = {
        page: this.page,
        limit: this.limit
      };
      this.$api.collectionlist(data).then(res => {
        if (res.status) {
          this.totalPage = Math.ceil(
            Number(res.data.count) / Number(this.limit)
          );
          this.list = res.data;
        }
      });
    },
    lookDetail(id) {
      this.$router.push({ path: "/arrowsdetail", query: { id } });
    },
    //分页加载
    handOrderMore(val) {
      this.page = val;
      this.getFavList();
    },
    // 取消收藏
    delCollete(val, index) {
        const _this = this
        this.$api.clubcollection({
            club_id: val.id
        }).then(res => {
            this.list.splice(index, 1)
            this.$message({
                message: _this.$t(successfullyCancel), // "取消成功",
                duration:1000
            })
        })
    }
  },
  created() {},
  mounted() {
    this.getFavList();
  }
};
</script>
<style lang="scss" scoped>
@import "./Favourite.scss";
</style>